import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { OBJ_COLOR } from "commons/constants";
import FileSaver from "file-saver";
import { User } from "models";
import { useState } from "react";
import * as XLSX from "xlsx";

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

interface ExportStatusUsersProps {
	users: User[] | undefined;
}
export const ExportStatusUsers = ({ users }: ExportStatusUsersProps) => {
	const [isLoading, setIsLoading] = useState(false);
	const handleOnClickExportData = () => {
		setIsLoading(true);

		const Heading = [{ stt: "Stt", userId: "Mã số nhân viên", name: "Tên", email: "Email", status: "Trạng thái" }];
		const wscols = [{ wch: 6 }, { wch: 10 }, { wch: 30 }, { wch: 30 }, { wch: 15 }];
		const header: any[] = [];

		const dataExport = users?.map((item, index) => {
			return {
				stt: index + 1,
				userId: item.id,
				email: item.email,
				name: item.name,
				status: item.status === 2 ? "Đã hoàn thành" : item.status === 1 ? "Đã xem" : "Chưa xem",
			};
		});

		const ws = XLSX.utils.json_to_sheet(Heading, {
			header,
			skipHeader: true,
		});
		ws["!cols"] = wscols;

		XLSX.utils.sheet_add_json(ws, dataExport || [], {
			header,
			skipHeader: true,
			origin: -1, //ok
		});
		const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
		const data = new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, "survey-users-status-2022" + fileExtension);
		setIsLoading(false);
	};

	return (
		<>
			<Button loading={isLoading} onClick={handleOnClickExportData} type="primary" style={{ background: OBJ_COLOR.INFO, borderColor: OBJ_COLOR.INFO }} icon={<DownloadOutlined />}>
				Export users status
			</Button>
		</>
	);
};
